import { GraphQLClient, RequestOptions } from 'graphql-request';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AppClientData: { input: import("@knapsack/types").KsAppClientData; output: import("@knapsack/types").KsAppClientData; }
  BlockConfig: { input: import("@knapsack/types").BlockConfig; output: import("@knapsack/types").BlockConfig; }
  FigmaProps: { input: Record<string, string | boolean | number>; output: Record<string, string | boolean | number>; }
  JSONObject: { input: Record<string, unknown>; output: Record<string, unknown>; }
  KsSpec: { input: import("@knapsack/types").KsTemplateSpec; output: import("@knapsack/types").KsTemplateSpec; }
  TokenDataSummary: { input: import("@knapsack/design-token-utils").TokenDataSummary; output: import("@knapsack/design-token-utils").TokenDataSummary; }
  VariantChild: { input: import("@knapsack/types").DesignSrcVariantChild; output: import("@knapsack/types").DesignSrcVariantChild; }
};

export type CacheControlScope =
  | 'PRIVATE'
  | 'PUBLIC';

export type DataChange = {
  inversePatches: Array<Scalars['JSONObject']['input']>;
  patches: Array<Scalars['JSONObject']['input']>;
};

export type DesignSourceFileStatus =
  | 'DONE'
  | 'ERROR'
  | 'NEW'
  | 'PROCESSING'
  | 'PROCESSING_FILE'
  | 'PROCESSING_IMAGE_CACHE'
  | 'PROCESSING_TEMP_URLS';

export type DesignSrcType =
  | 'FIGMA';

export type FileType =
  | 'SITE'
  | 'USER';

export type GitProviders_Enum =
  | 'azure'
  | 'bitbucketCloud'
  | 'bitbucketServer'
  | 'gitHub'
  | 'gitLab'
  | 'gitLabRest'
  | 'none';

export type InstanceStatus =
  | 'DELETED'
  | 'DRAFT'
  | 'PROPOSED'
  | 'PROPOSING'
  | 'PUBLISHED'
  | 'PUBLISHING';

export type Plans_Enum =
  | 'L20'
  | 'L40';

export type PresignRequest = {
  fileName: Scalars['String']['input'];
  fileType: FileType;
  mimeType: Scalars['String']['input'];
  siteId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type RendererId =
  | 'angular'
  | 'hbs'
  | 'html'
  | 'react'
  | 'twig'
  | 'vue'
  | 'webComponents';

export type Roles_Enum_Faked_From_Db =
  | 'ADMIN'
  | 'ANONYMOUS'
  | 'CONSUMER'
  | 'CONTRIBUTOR'
  | 'EDITOR'
  | 'MANAGER'
  | 'VIEWER';

export type SiteAuthType =
  | 'SSO'
  | 'UP';

export type SiteStatuses_Enum =
  | 'ACTIVE'
  | 'ARCHIVED'
  | 'DISABLED'
  | 'INACTIVE'
  | 'PREPARING';

export type ZenDeskTicketIssueCategory =
  | 'ACCOUNT_SUPPORT'
  | 'BUG'
  | 'FEATURE_REQUEST'
  | 'PRODUCT_HELP';

export type ZenDeskTicketPriority =
  | 'high'
  | 'low'
  | 'normal'
  | 'urgent';

export type ZendeskTicketType =
  | 'CSAT'
  | 'SUPPORT';

export type BranchInfoQueryVariables = Exact<{
  siteId: Scalars['String']['input'];
  branch: Scalars['String']['input'];
}>;


export type BranchInfoQuery = { __typename?: 'Query', branchInfo: { __typename?: 'BranchInfo', gitSha: string, gitShaFull: string, prs: Array<{ __typename?: 'prInfo', prNumber: number, isMergeable: boolean, hasConflicts: boolean, prUrl: string, title: string }> } };

export type PreSignS3UrlQueryVariables = Exact<{
  presignRequest: PresignRequest;
}>;


export type PreSignS3UrlQuery = { __typename?: 'Query', preSignS3URL: string };

export type ConvertTokensSpecToTokenFilesDataQueryVariables = Exact<{
  tokensSrc: Scalars['JSONObject']['input'];
}>;


export type ConvertTokensSpecToTokenFilesDataQuery = { __typename?: 'Query', convertTokensSpecToTokenFilesData: { __typename?: 'TokenFiles', tokenFiles: Array<{ __typename?: 'TokenFile', contents: string, path: string }> } };

export type ConvertTokensSpecToTokenFilesZipQueryVariables = Exact<{
  tokensSrc: Scalars['JSONObject']['input'];
}>;


export type ConvertTokensSpecToTokenFilesZipQuery = { __typename?: 'Query', convertTokensSpecToTokenFilesZip: { __typename?: 'Base64', base64Body: string } };

export type CreateNewSiteMutationVariables = Exact<{
  siteId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  roleId: Roles_Enum_Faked_From_Db;
  hasReact: Scalars['Boolean']['input'];
  gitHubUserName?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateNewSiteMutation = { __typename?: 'Mutation', createKsSite: { __typename?: 'msgRes', msg: string }, inviteUserToSite: { __typename?: 'AddUserRes', userId: string, isNewUser: boolean, siteUrl?: string | null } };

export type FixInstanceMergeConflictMutationVariables = Exact<{
  siteId: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
}>;


export type FixInstanceMergeConflictMutation = { __typename?: 'Mutation', fixInstanceMergeConflict: { __typename?: 'prInfoBasic', prNumber: number, prUrl: string } };

export type CreateZendeskTicketMutationVariables = Exact<{
  subject: Scalars['String']['input'];
  comment: Scalars['String']['input'];
  issueCategory: ZenDeskTicketIssueCategory;
  priority: ZenDeskTicketPriority;
  ticketType: ZendeskTicketType;
}>;


export type CreateZendeskTicketMutation = { __typename?: 'Mutation', createZenDeskTicket: { __typename?: 'msgRes', msg: string } };

export type CreateInstanceAndBranchMutationVariables = Exact<{
  siteId: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  appClientDataMajorVersion: Scalars['Int']['input'];
}>;


export type CreateInstanceAndBranchMutation = { __typename?: 'Mutation', createInstanceAndBranch?: { __typename?: 'createInstanceAndBranchRes', branch?: string | null, instanceId: string, title: string } | null };

export type CommitChangesOnInstanceMutationVariables = Exact<{
  commitMsg: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
}>;


export type CommitChangesOnInstanceMutation = { __typename?: 'Mutation', commitChangesOnInstance: { __typename?: 'commitChangesOnInstanceRes', lastDataChangeId: string } };

export type DeleteInstanceMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
}>;


export type DeleteInstanceMutation = { __typename?: 'Mutation', deleteInstance: boolean };

export type RequestBranchReviewMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
}>;


export type RequestBranchReviewMutation = { __typename?: 'Mutation', requestBranchReview: { __typename?: 'prInfoBasic', prNumber: number, prUrl: string } };

export type PublishBranchMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
}>;


export type PublishBranchMutation = { __typename?: 'Mutation', publishBranch: { __typename?: 'prInfoBasic', prNumber: number, prUrl: string } };

export type ConvertProposedInstanceToDraftMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
}>;


export type ConvertProposedInstanceToDraftMutation = { __typename?: 'Mutation', convertProposedInstanceToDraft: boolean };

export type UpdateBranchContentMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
  changes: Array<DataChange> | DataChange;
}>;


export type UpdateBranchContentMutation = { __typename?: 'Mutation', updateBranchContent?: { __typename?: 'updateBranchContentRes', dataChangeId?: string | null } | null };

export type GetSiteContentAndMetaQueryVariables = Exact<{
  instanceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSiteContentAndMetaQuery = { __typename?: 'Query', site: { __typename?: 'Site', meta: { __typename?: 'SiteMeta', orgId?: string | null, prodEnvUrl: string, isKsContentStoredInDb: boolean, repoUrl: string, siteId: string, isPrivate: boolean, gitProviderType: GitProviders_Enum, plan: Plans_Enum, status: SiteStatuses_Enum, title?: string | null }, appClientDataInfo: { __typename?: 'AppClientDataInfo', appClientData: import("@knapsack/types").KsAppClientData, gitBranch?: string | null, instanceId?: string | null, instanceStatus?: InstanceStatus | null, lastDataChangeId?: string | null, lastCommittedDataChangeId?: string | null, tokens: { __typename?: 'Tokens', fromCache: boolean, tokenData: import("@knapsack/design-token-utils").TokenDataSummary, tokenStyles: string } } } };

export type GetDesignSrcFileBasicInfoQueryVariables = Exact<{
  fileId: Scalars['String']['input'];
  version: Scalars['String']['input'];
}>;


export type GetDesignSrcFileBasicInfoQuery = { __typename?: 'Query', designSrcFile: { __typename?: 'DesignSrcFile', version: { __typename?: 'DesignSrcFileVersion', statusId?: DesignSourceFileStatus | null, name: string, url: string } } };

export type GetDesignSrcComponentsQueryVariables = Exact<{
  fileId: Scalars['String']['input'];
  version: Scalars['String']['input'];
}>;


export type GetDesignSrcComponentsQuery = { __typename?: 'Query', designSrcFile: { __typename?: 'DesignSrcFile', version: { __typename?: 'DesignSrcFileVersion', statusId?: DesignSourceFileStatus | null, components: Array<{ __typename?: 'DesignSrcComponent', nodeId: string, name: string, url: string, spec?: import("@knapsack/types").KsTemplateSpec | null, variants: Array<{ __typename?: 'DesignSrcComponentVariant', nodeId: string, imgUrl?: string | null, width?: number | null, height?: number | null }> }> } } };

export type GetDesignSrcComponentQueryVariables = Exact<{
  fileId: Scalars['String']['input'];
  version: Scalars['String']['input'];
  componentId: Scalars['String']['input'];
}>;


export type GetDesignSrcComponentQuery = { __typename?: 'Query', designSrcFile: { __typename?: 'DesignSrcFile', version: { __typename?: 'DesignSrcFileVersion', statusId?: DesignSourceFileStatus | null, component: { __typename?: 'DesignSrcComponent', name: string, spec?: import("@knapsack/types").KsTemplateSpec | null, variants: Array<{ __typename?: 'DesignSrcComponentVariant', nodeId: string, name: string, width?: number | null, height?: number | null, imgUrl?: string | null, props: Record<string, string | boolean | number>, children: Array<import("@knapsack/types").DesignSrcVariantChild>, url: string, instances: Array<{ __typename?: 'DesignSrcVariantInstance', nodeId: string, name: string, url: string, usedInInstances: Array<{ __typename?: 'DesignSrcVariantInstance', nodeId: string, name: string, url: string, component: { __typename?: 'DesignSrcComponent', name: string, nodeId: string } }> }> }> } } } };

export type GetDesignSrcFileInfoQueryVariables = Exact<{
  fileId: Scalars['String']['input'];
  version: Scalars['String']['input'];
}>;


export type GetDesignSrcFileInfoQuery = { __typename?: 'Query', designSrcFile: { __typename?: 'DesignSrcFile', url: string, type: DesignSrcType, version: { __typename?: 'DesignSrcFileVersion', statusId?: DesignSourceFileStatus | null, url: string, name: string, createdAt: string, components: Array<{ __typename?: 'DesignSrcComponent', name: string, nodeId: string }>, nodes: Array<{ __typename: 'DesignSrcComponent', name: string, nodeId: string } | { __typename: 'DesignSrcComponentVariant', name: string, nodeId: string } | { __typename: 'DesignSrcFrame', name: string, nodeId: string } | { __typename: 'DesignSrcPage', name: string, nodeId: string } | { __typename: 'DesignSrcSlice', name: string, nodeId: string } | { __typename: 'DesignSrcVariantInstance', name: string, nodeId: string }>, pages: Array<{ __typename?: 'DesignSrcPage', name: string, nodeId: string }>, slices: Array<{ __typename?: 'DesignSrcSlice', name: string, nodeId: string }>, frames: Array<{ __typename?: 'DesignSrcFrame', name: string, nodeId: string }> } } };

export type GetDesignSrcFileContentsQueryVariables = Exact<{
  fileId: Scalars['String']['input'];
  version: Scalars['String']['input'];
}>;


export type GetDesignSrcFileContentsQuery = { __typename?: 'Query', designSrcFile: { __typename?: 'DesignSrcFile', version: { __typename?: 'DesignSrcFileVersion', statusId?: DesignSourceFileStatus | null, components: Array<{ __typename: 'DesignSrcComponent', name: string, nodeId: string, url: string, height?: number | null, width?: number | null, path: Array<{ __typename?: 'DesignSrcPath', name: string, figmaType: string, nodeId: string }>, variants: Array<{ __typename: 'DesignSrcComponentVariant', name: string, nodeId: string, url: string, height?: number | null, width?: number | null, path: Array<{ __typename?: 'DesignSrcPath', name: string, figmaType: string, nodeId: string }>, instances: Array<{ __typename: 'DesignSrcVariantInstance', name: string, nodeId: string, url: string, height?: number | null, width?: number | null, path: Array<{ __typename?: 'DesignSrcPath', name: string, figmaType: string, nodeId: string }> }> }> }>, pages: Array<{ __typename?: 'DesignSrcPage', name: string, nodeId: string, url: string, slices: Array<{ __typename: 'DesignSrcSlice', name: string, nodeId: string, url: string, height?: number | null, width?: number | null, path: Array<{ __typename?: 'DesignSrcPath', name: string, figmaType: string, nodeId: string }> }>, frames: Array<{ __typename: 'DesignSrcFrame', name: string, nodeId: string, url: string, height?: number | null, width?: number | null, children: Array<import("@knapsack/types").DesignSrcVariantChild>, path: Array<{ __typename?: 'DesignSrcPath', name: string, figmaType: string, nodeId: string }> }> }> } } };

export type GetDesignSrcNodeImageQueryVariables = Exact<{
  fileId: Scalars['String']['input'];
  version: Scalars['String']['input'];
  nodeId: Scalars['String']['input'];
}>;


export type GetDesignSrcNodeImageQuery = { __typename?: 'Query', designSrcFile: { __typename?: 'DesignSrcFile', version: { __typename?: 'DesignSrcFileVersion', statusId?: DesignSourceFileStatus | null, node: { __typename: 'DesignSrcComponent', name: string, nodeId: string, imgUrl?: string | null, url: string, height?: number | null, width?: number | null } | { __typename: 'DesignSrcComponentVariant', props: Record<string, string | boolean | number>, children: Array<import("@knapsack/types").DesignSrcVariantChild>, name: string, nodeId: string, imgUrl?: string | null, url: string, height?: number | null, width?: number | null } | { __typename: 'DesignSrcFrame', name: string, nodeId: string, imgUrl?: string | null, url: string, height?: number | null, width?: number | null } | { __typename: 'DesignSrcPage', name: string, nodeId: string, imgUrl: string, url: string, height?: number | null, width?: number | null } | { __typename: 'DesignSrcSlice', name: string, nodeId: string, imgUrl?: string | null, url: string, height?: number | null, width?: number | null } | { __typename: 'DesignSrcVariantInstance', name: string, nodeId: string, imgUrl?: string | null, url: string, height?: number | null, width?: number | null } } } };

export type GetDesignSrcNodeImagesQueryVariables = Exact<{
  fileId: Scalars['String']['input'];
  version: Scalars['String']['input'];
  nodeIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetDesignSrcNodeImagesQuery = { __typename?: 'Query', designSrcFile: { __typename?: 'DesignSrcFile', version: { __typename?: 'DesignSrcFileVersion', statusId?: DesignSourceFileStatus | null, nodes: Array<{ __typename: 'DesignSrcComponent', name: string, nodeId: string, imgUrl?: string | null, url: string, height?: number | null, width?: number | null } | { __typename: 'DesignSrcComponentVariant', props: Record<string, string | boolean | number>, children: Array<import("@knapsack/types").DesignSrcVariantChild>, name: string, nodeId: string, imgUrl?: string | null, url: string, height?: number | null, width?: number | null, component: { __typename?: 'DesignSrcComponent', nodeId: string } } | { __typename: 'DesignSrcFrame', name: string, nodeId: string, imgUrl?: string | null, url: string, height?: number | null, width?: number | null } | { __typename: 'DesignSrcPage', name: string, nodeId: string, imgUrl: string, url: string, height?: number | null, width?: number | null } | { __typename: 'DesignSrcSlice', name: string, nodeId: string, imgUrl?: string | null, url: string, height?: number | null, width?: number | null } | { __typename: 'DesignSrcVariantInstance', name: string, nodeId: string, imgUrl?: string | null, url: string, height?: number | null, width?: number | null }> } } };

export type AddDesignSrcFileAsyncMutationVariables = Exact<{
  fileId: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
  url: Scalars['String']['input'];
  version: Scalars['String']['input'];
  type: DesignSrcType;
}>;


export type AddDesignSrcFileAsyncMutation = { __typename?: 'Mutation', addDesignSrcFileAsync: { __typename?: 'AddFileAsyncResult', fileId: string, name: string, version: string } };

export type GetDesignSrcFileLatestVersionQueryVariables = Exact<{
  fileId: Scalars['String']['input'];
}>;


export type GetDesignSrcFileLatestVersionQuery = { __typename?: 'Query', latestDesignSrcFileVersion: { __typename?: 'LatestDesignSrcFileVersion', version: string } };

export type GetFigmaFileMetadataQueryVariables = Exact<{
  fileId: Scalars['String']['input'];
  version: Scalars['String']['input'];
}>;


export type GetFigmaFileMetadataQuery = { __typename?: 'Query', figmaFileMetadata: { __typename?: 'FigmaFileMetadata', componentCount: number, createdAt: string, frameCount: number, name: string, pageCount: number, statusId: DesignSourceFileStatus, type: DesignSrcType, url: string, variantCount: number } };

export type GetFigmaUserInfoQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetFigmaUserInfoQuery = { __typename?: 'Query', figmaUserInfo: { __typename?: 'FigmaUserInfo', email: string, id: string, tokenLastUsed: string, tokenExpiresAt: string } };

export type DeleteDesignSrcUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  sourceUserId: Scalars['String']['input'];
}>;


export type DeleteDesignSrcUserMutation = { __typename?: 'Mutation', deleteDesignSrcUser: { __typename?: 'DeleteFigmaUserResult', userId: string } };

export type GetInvitedUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInvitedUsersQuery = { __typename?: 'Query', invitedUsers: Array<{ __typename?: 'InvitedUser', email: string, roleId: Roles_Enum_Faked_From_Db, isUserPass: boolean, dateCreated: string, dateOfInviteExpiration?: string | null }> };

export type InviteUserMutationVariables = Exact<{
  siteId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  roleId: Roles_Enum_Faked_From_Db;
  authType?: InputMaybe<SiteAuthType>;
}>;


export type InviteUserMutation = { __typename?: 'Mutation', inviteUserToSite: { __typename?: 'AddUserRes', userId: string, isNewUser: boolean } };

export type RemoveInvitedUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
}>;


export type RemoveInvitedUserMutation = { __typename?: 'Mutation', removeInvitedUser: boolean };

export type GetPageQueryVariables = Exact<{
  instanceId?: InputMaybe<Scalars['String']['input']>;
  pageId: Scalars['String']['input'];
}>;


export type GetPageQuery = { __typename?: 'Query', site: { __typename?: 'Site', appClientDataInfo: { __typename?: 'AppClientDataInfo', content: { __typename?: 'Content', page: { __typename?: 'Page', id: string, title: string, description?: string | null, tabs: Array<{ __typename?: 'Tab', title: string, blocks: Array<{ __typename?: 'Block', id: string, html: string, config: import("@knapsack/types").BlockConfig }> }> } } } } };

export type GetPageListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPageListQuery = { __typename?: 'Query', site: { __typename?: 'Site', appClientDataInfo: { __typename?: 'AppClientDataInfo', content: { __typename?: 'Content', pages: Array<{ __typename?: 'Page', id: string, title: string, description?: string | null }> } } } };

export type GetPatternQueryVariables = Exact<{
  instanceId?: InputMaybe<Scalars['String']['input']>;
  patternId: Scalars['String']['input'];
}>;


export type GetPatternQuery = { __typename?: 'Query', site: { __typename?: 'Site', appClientDataInfo: { __typename?: 'AppClientDataInfo', content: { __typename?: 'Content', pattern: { __typename?: 'Pattern', id: string, title: string, description?: string | null, docs: Array<{ __typename?: 'Tab', title: string, blocks: Array<{ __typename?: 'Block', id: string, html: string, config: import("@knapsack/types").BlockConfig }> }>, templates: Array<{ __typename?: 'Template', id: string, rendererId: RendererId, path?: string | null, alias?: string | null }> } } } } };

export type GetPatternListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPatternListQuery = { __typename?: 'Query', site: { __typename?: 'Site', appClientDataInfo: { __typename?: 'AppClientDataInfo', content: { __typename?: 'Content', patterns: Array<{ __typename?: 'Pattern', id: string, title: string, description?: string | null, templates: Array<{ __typename?: 'Template', id: string, rendererId: RendererId, path?: string | null, alias?: string | null }> }> } } } };

export type UpdateSiteSetupMutationVariables = Exact<{
  siteId: Scalars['String']['input'];
  prodUrl?: InputMaybe<Scalars['String']['input']>;
  gitProvider?: InputMaybe<GitProviders_Enum>;
  repoUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateSiteSetupMutation = { __typename?: 'Mutation', updateSiteSetup: boolean };

export type IsGitConfiguredCorrectlyQueryVariables = Exact<{ [key: string]: never; }>;


export type IsGitConfiguredCorrectlyQuery = { __typename?: 'Query', site: { __typename?: 'Site', isGitConfiguredCorrectly: boolean } };

export type IsAppClientConfiguredCorrectlyQueryVariables = Exact<{
  url: Scalars['String']['input'];
}>;


export type IsAppClientConfiguredCorrectlyQuery = { __typename?: 'Query', site: { __typename?: 'Site', isAppClientConfiguredCorrectly: boolean } };

export const NodeInfoFragmentDoc = /*#__PURE__*/ `
    fragment NodeInfo on DesignSrcNode {
  __typename
  name
  nodeId
  url
  height
  width
  path {
    name
    figmaType
    nodeId
  }
}
    `;
export const BranchInfoDocument = /*#__PURE__*/ `
    query branchInfo($siteId: String!, $branch: String!) {
  branchInfo(branch: $branch, siteId: $siteId) {
    gitSha
    gitShaFull
    prs {
      prNumber
      isMergeable
      hasConflicts
      prUrl
      title
    }
  }
}
    `;
export const PreSignS3UrlDocument = /*#__PURE__*/ `
    query preSignS3URL($presignRequest: PresignRequest!) {
  preSignS3URL(presignRequest: $presignRequest)
}
    `;
export const ConvertTokensSpecToTokenFilesDataDocument = /*#__PURE__*/ `
    query convertTokensSpecToTokenFilesData($tokensSrc: JSONObject!) {
  convertTokensSpecToTokenFilesData(tokensSrc: $tokensSrc) {
    tokenFiles {
      contents
      path
    }
  }
}
    `;
export const ConvertTokensSpecToTokenFilesZipDocument = /*#__PURE__*/ `
    query convertTokensSpecToTokenFilesZip($tokensSrc: JSONObject!) {
  convertTokensSpecToTokenFilesZip(tokensSrc: $tokensSrc) {
    base64Body
  }
}
    `;
export const CreateNewSiteDocument = /*#__PURE__*/ `
    mutation createNewSite($siteId: String!, $email: String!, $roleId: Roles_Enum_Faked_From_Db!, $hasReact: Boolean!, $gitHubUserName: String) {
  createKsSite(
    siteId: $siteId
    hasReact: $hasReact
    gitHubUserName: $gitHubUserName
  ) {
    msg
  }
  inviteUserToSite(siteId: $siteId, email: $email, roleId: $roleId) {
    userId
    isNewUser
    siteUrl
  }
}
    `;
export const FixInstanceMergeConflictDocument = /*#__PURE__*/ `
    mutation fixInstanceMergeConflict($siteId: String!, $instanceId: String!) {
  fixInstanceMergeConflict(siteId: $siteId, instanceId: $instanceId) {
    prNumber
    prUrl
  }
}
    `;
export const CreateZendeskTicketDocument = /*#__PURE__*/ `
    mutation createZendeskTicket($subject: String!, $comment: String!, $issueCategory: ZenDeskTicketIssueCategory!, $priority: ZenDeskTicketPriority!, $ticketType: ZendeskTicketType!) {
  createZenDeskTicket(
    subject: $subject
    comment: $comment
    issueCategory: $issueCategory
    priority: $priority
    ticketType: $ticketType
  ) {
    msg
  }
}
    `;
export const CreateInstanceAndBranchDocument = /*#__PURE__*/ `
    mutation createInstanceAndBranch($siteId: String!, $title: String, $appClientDataMajorVersion: Int!) {
  createInstanceAndBranch(
    title: $title
    siteId: $siteId
    appClientDataMajorVersion: $appClientDataMajorVersion
  ) {
    branch
    instanceId
    title
  }
}
    `;
export const CommitChangesOnInstanceDocument = /*#__PURE__*/ `
    mutation commitChangesOnInstance($commitMsg: String!, $instanceId: String!, $siteId: String!) {
  commitChangesOnInstance(
    commitMsg: $commitMsg
    instanceId: $instanceId
    siteId: $siteId
  ) {
    lastDataChangeId
  }
}
    `;
export const DeleteInstanceDocument = /*#__PURE__*/ `
    mutation deleteInstance($instanceId: String!) {
  deleteInstance(instanceId: $instanceId)
}
    `;
export const RequestBranchReviewDocument = /*#__PURE__*/ `
    mutation requestBranchReview($instanceId: String!) {
  requestBranchReview(instanceId: $instanceId) {
    prNumber
    prUrl
  }
}
    `;
export const PublishBranchDocument = /*#__PURE__*/ `
    mutation publishBranch($instanceId: String!) {
  publishBranch(instanceId: $instanceId) {
    prNumber
    prUrl
  }
}
    `;
export const ConvertProposedInstanceToDraftDocument = /*#__PURE__*/ `
    mutation convertProposedInstanceToDraft($instanceId: String!) {
  convertProposedInstanceToDraft(instanceId: $instanceId)
}
    `;
export const UpdateBranchContentDocument = /*#__PURE__*/ `
    mutation updateBranchContent($instanceId: String!, $changes: [DataChange!]!) {
  updateBranchContent(instanceId: $instanceId, changes: $changes) {
    dataChangeId
  }
}
    `;
export const GetSiteContentAndMetaDocument = /*#__PURE__*/ `
    query getSiteContentAndMeta($instanceId: String) {
  site(instanceId: $instanceId) {
    meta {
      orgId
      prodEnvUrl
      isKsContentStoredInDb
      repoUrl
      siteId
      isPrivate
      gitProviderType
      plan
      status
      title
    }
    appClientDataInfo {
      appClientData
      gitBranch
      instanceId
      instanceStatus
      lastDataChangeId
      lastCommittedDataChangeId
      tokens {
        fromCache
        tokenData
        tokenStyles
      }
    }
  }
}
    `;
export const GetDesignSrcFileBasicInfoDocument = /*#__PURE__*/ `
    query getDesignSrcFileBasicInfo($fileId: String!, $version: String!) {
  designSrcFile(fileId: $fileId) {
    version(version: $version) {
      statusId
      name
      url
    }
  }
}
    `;
export const GetDesignSrcComponentsDocument = /*#__PURE__*/ `
    query getDesignSrcComponents($fileId: String!, $version: String!) {
  designSrcFile(fileId: $fileId) {
    version(version: $version) {
      statusId
      components {
        nodeId
        name
        url
        spec
        variants {
          nodeId
          imgUrl
          width
          height
        }
      }
    }
  }
}
    `;
export const GetDesignSrcComponentDocument = /*#__PURE__*/ `
    query getDesignSrcComponent($fileId: String!, $version: String!, $componentId: String!) {
  designSrcFile(fileId: $fileId) {
    version(version: $version) {
      statusId
      component(id: $componentId) {
        name
        spec
        variants {
          nodeId
          name
          width
          height
          imgUrl
          ... on DesignSrcComponentVariant {
            props
            children
          }
          url
          instances {
            nodeId
            name
            url
            usedInInstances {
              nodeId
              name
              url
              component {
                name
                nodeId
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const GetDesignSrcFileInfoDocument = /*#__PURE__*/ `
    query getDesignSrcFileInfo($fileId: String!, $version: String!) {
  designSrcFile(fileId: $fileId) {
    url
    type
    version(version: $version) {
      statusId
      url
      name
      createdAt
      components {
        name
        nodeId
      }
      nodes {
        __typename
        name
        nodeId
      }
      pages {
        name
        nodeId
      }
      slices {
        name
        nodeId
      }
      frames {
        name
        nodeId
      }
    }
  }
}
    `;
export const GetDesignSrcFileContentsDocument = /*#__PURE__*/ `
    query getDesignSrcFileContents($fileId: String!, $version: String!) {
  designSrcFile(fileId: $fileId) {
    version(version: $version) {
      statusId
      components {
        ...NodeInfo
        variants {
          ...NodeInfo
          instances {
            ...NodeInfo
          }
        }
      }
      pages {
        name
        nodeId
        url
        slices {
          ...NodeInfo
        }
        frames {
          ...NodeInfo
          children
        }
      }
    }
  }
}
    ${NodeInfoFragmentDoc}`;
export const GetDesignSrcNodeImageDocument = /*#__PURE__*/ `
    query getDesignSrcNodeImage($fileId: String!, $version: String!, $nodeId: String!) {
  designSrcFile(fileId: $fileId) {
    version(version: $version) {
      statusId
      node(nodeId: $nodeId) {
        __typename
        name
        nodeId
        imgUrl
        url
        height
        width
        ... on DesignSrcComponentVariant {
          props
          children
        }
      }
    }
  }
}
    `;
export const GetDesignSrcNodeImagesDocument = /*#__PURE__*/ `
    query getDesignSrcNodeImages($fileId: String!, $version: String!, $nodeIds: [String!]!) {
  designSrcFile(fileId: $fileId) {
    version(version: $version) {
      statusId
      nodes(nodeIds: $nodeIds) {
        __typename
        name
        nodeId
        imgUrl
        url
        height
        width
        ... on DesignSrcComponentVariant {
          props
          children
          component {
            nodeId
          }
        }
      }
    }
  }
}
    `;
export const AddDesignSrcFileAsyncDocument = /*#__PURE__*/ `
    mutation addDesignSrcFileAsync($fileId: String!, $siteId: String!, $url: String!, $version: String!, $type: DesignSrcType!) {
  addDesignSrcFileAsync(
    fileId: $fileId
    siteId: $siteId
    url: $url
    version: $version
    type: $type
  ) {
    fileId
    name
    version
  }
}
    `;
export const GetDesignSrcFileLatestVersionDocument = /*#__PURE__*/ `
    query getDesignSrcFileLatestVersion($fileId: String!) {
  latestDesignSrcFileVersion(fileId: $fileId) {
    version
  }
}
    `;
export const GetFigmaFileMetadataDocument = /*#__PURE__*/ `
    query getFigmaFileMetadata($fileId: String!, $version: String!) {
  figmaFileMetadata(fileId: $fileId, version: $version) {
    componentCount
    createdAt
    frameCount
    name
    pageCount
    statusId
    type
    url
    variantCount
  }
}
    `;
export const GetFigmaUserInfoDocument = /*#__PURE__*/ `
    query getFigmaUserInfo($userId: String!) {
  figmaUserInfo(userId: $userId) {
    email
    id
    tokenLastUsed
    tokenExpiresAt
  }
}
    `;
export const DeleteDesignSrcUserDocument = /*#__PURE__*/ `
    mutation deleteDesignSrcUser($userId: String!, $sourceUserId: String!) {
  deleteDesignSrcUser(userId: $userId, sourceUserId: $sourceUserId) {
    userId
  }
}
    `;
export const GetInvitedUsersDocument = /*#__PURE__*/ `
    query getInvitedUsers {
  invitedUsers {
    email
    roleId
    isUserPass
    dateCreated
    dateOfInviteExpiration
  }
}
    `;
export const InviteUserDocument = /*#__PURE__*/ `
    mutation inviteUser($siteId: String!, $email: String!, $roleId: Roles_Enum_Faked_From_Db!, $authType: SiteAuthType) {
  inviteUserToSite(
    siteId: $siteId
    email: $email
    roleId: $roleId
    authType: $authType
  ) {
    userId
    isNewUser
  }
}
    `;
export const RemoveInvitedUserDocument = /*#__PURE__*/ `
    mutation removeInvitedUser($email: String!, $siteId: String!) {
  removeInvitedUser(email: $email, siteId: $siteId)
}
    `;
export const GetPageDocument = /*#__PURE__*/ `
    query getPage($instanceId: String, $pageId: String!) {
  site(instanceId: $instanceId) {
    appClientDataInfo {
      content {
        page(pageId: $pageId) {
          id
          title
          description
          tabs {
            title
            blocks {
              id
              html
              config
            }
          }
        }
      }
    }
  }
}
    `;
export const GetPageListDocument = /*#__PURE__*/ `
    query getPageList {
  site {
    appClientDataInfo {
      content {
        pages {
          id
          title
          description
        }
      }
    }
  }
}
    `;
export const GetPatternDocument = /*#__PURE__*/ `
    query getPattern($instanceId: String, $patternId: String!) {
  site(instanceId: $instanceId) {
    appClientDataInfo {
      content {
        pattern(patternId: $patternId) {
          id
          title
          description
          docs {
            title
            blocks {
              id
              html
              config
            }
          }
          templates {
            id
            rendererId
            path
            alias
          }
        }
      }
    }
  }
}
    `;
export const GetPatternListDocument = /*#__PURE__*/ `
    query getPatternList {
  site {
    appClientDataInfo {
      content {
        patterns {
          id
          title
          description
          templates {
            id
            rendererId
            path
            alias
          }
        }
      }
    }
  }
}
    `;
export const UpdateSiteSetupDocument = /*#__PURE__*/ `
    mutation updateSiteSetup($siteId: String!, $prodUrl: String, $gitProvider: GitProviders_Enum, $repoUrl: String) {
  updateSiteSetup(
    siteId: $siteId
    prodUrl: $prodUrl
    gitProvider: $gitProvider
    repoUrl: $repoUrl
  )
}
    `;
export const IsGitConfiguredCorrectlyDocument = /*#__PURE__*/ `
    query isGitConfiguredCorrectly {
  site {
    isGitConfiguredCorrectly
  }
}
    `;
export const IsAppClientConfiguredCorrectlyDocument = /*#__PURE__*/ `
    query isAppClientConfiguredCorrectly($url: String!) {
  site {
    isAppClientConfiguredCorrectly(url: $url)
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    branchInfo(variables: BranchInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<BranchInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BranchInfoQuery>({ document: BranchInfoDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'branchInfo', 'query', variables);
    },
    preSignS3URL(variables: PreSignS3UrlQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PreSignS3UrlQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PreSignS3UrlQuery>({ document: PreSignS3UrlDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'preSignS3URL', 'query', variables);
    },
    convertTokensSpecToTokenFilesData(variables: ConvertTokensSpecToTokenFilesDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ConvertTokensSpecToTokenFilesDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConvertTokensSpecToTokenFilesDataQuery>({ document: ConvertTokensSpecToTokenFilesDataDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'convertTokensSpecToTokenFilesData', 'query', variables);
    },
    convertTokensSpecToTokenFilesZip(variables: ConvertTokensSpecToTokenFilesZipQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ConvertTokensSpecToTokenFilesZipQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConvertTokensSpecToTokenFilesZipQuery>({ document: ConvertTokensSpecToTokenFilesZipDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'convertTokensSpecToTokenFilesZip', 'query', variables);
    },
    createNewSite(variables: CreateNewSiteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateNewSiteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateNewSiteMutation>({ document: CreateNewSiteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'createNewSite', 'mutation', variables);
    },
    fixInstanceMergeConflict(variables: FixInstanceMergeConflictMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FixInstanceMergeConflictMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FixInstanceMergeConflictMutation>({ document: FixInstanceMergeConflictDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'fixInstanceMergeConflict', 'mutation', variables);
    },
    createZendeskTicket(variables: CreateZendeskTicketMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateZendeskTicketMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateZendeskTicketMutation>({ document: CreateZendeskTicketDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'createZendeskTicket', 'mutation', variables);
    },
    createInstanceAndBranch(variables: CreateInstanceAndBranchMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateInstanceAndBranchMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateInstanceAndBranchMutation>({ document: CreateInstanceAndBranchDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'createInstanceAndBranch', 'mutation', variables);
    },
    commitChangesOnInstance(variables: CommitChangesOnInstanceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CommitChangesOnInstanceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CommitChangesOnInstanceMutation>({ document: CommitChangesOnInstanceDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'commitChangesOnInstance', 'mutation', variables);
    },
    deleteInstance(variables: DeleteInstanceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteInstanceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteInstanceMutation>({ document: DeleteInstanceDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'deleteInstance', 'mutation', variables);
    },
    requestBranchReview(variables: RequestBranchReviewMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RequestBranchReviewMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RequestBranchReviewMutation>({ document: RequestBranchReviewDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'requestBranchReview', 'mutation', variables);
    },
    publishBranch(variables: PublishBranchMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PublishBranchMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PublishBranchMutation>({ document: PublishBranchDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'publishBranch', 'mutation', variables);
    },
    convertProposedInstanceToDraft(variables: ConvertProposedInstanceToDraftMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ConvertProposedInstanceToDraftMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConvertProposedInstanceToDraftMutation>({ document: ConvertProposedInstanceToDraftDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'convertProposedInstanceToDraft', 'mutation', variables);
    },
    updateBranchContent(variables: UpdateBranchContentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateBranchContentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateBranchContentMutation>({ document: UpdateBranchContentDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'updateBranchContent', 'mutation', variables);
    },
    getSiteContentAndMeta(variables?: GetSiteContentAndMetaQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetSiteContentAndMetaQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSiteContentAndMetaQuery>({ document: GetSiteContentAndMetaDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getSiteContentAndMeta', 'query', variables);
    },
    getDesignSrcFileBasicInfo(variables: GetDesignSrcFileBasicInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetDesignSrcFileBasicInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDesignSrcFileBasicInfoQuery>({ document: GetDesignSrcFileBasicInfoDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getDesignSrcFileBasicInfo', 'query', variables);
    },
    getDesignSrcComponents(variables: GetDesignSrcComponentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetDesignSrcComponentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDesignSrcComponentsQuery>({ document: GetDesignSrcComponentsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getDesignSrcComponents', 'query', variables);
    },
    getDesignSrcComponent(variables: GetDesignSrcComponentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetDesignSrcComponentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDesignSrcComponentQuery>({ document: GetDesignSrcComponentDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getDesignSrcComponent', 'query', variables);
    },
    getDesignSrcFileInfo(variables: GetDesignSrcFileInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetDesignSrcFileInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDesignSrcFileInfoQuery>({ document: GetDesignSrcFileInfoDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getDesignSrcFileInfo', 'query', variables);
    },
    getDesignSrcFileContents(variables: GetDesignSrcFileContentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetDesignSrcFileContentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDesignSrcFileContentsQuery>({ document: GetDesignSrcFileContentsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getDesignSrcFileContents', 'query', variables);
    },
    getDesignSrcNodeImage(variables: GetDesignSrcNodeImageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetDesignSrcNodeImageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDesignSrcNodeImageQuery>({ document: GetDesignSrcNodeImageDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getDesignSrcNodeImage', 'query', variables);
    },
    getDesignSrcNodeImages(variables: GetDesignSrcNodeImagesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetDesignSrcNodeImagesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDesignSrcNodeImagesQuery>({ document: GetDesignSrcNodeImagesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getDesignSrcNodeImages', 'query', variables);
    },
    addDesignSrcFileAsync(variables: AddDesignSrcFileAsyncMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AddDesignSrcFileAsyncMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddDesignSrcFileAsyncMutation>({ document: AddDesignSrcFileAsyncDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'addDesignSrcFileAsync', 'mutation', variables);
    },
    getDesignSrcFileLatestVersion(variables: GetDesignSrcFileLatestVersionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetDesignSrcFileLatestVersionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDesignSrcFileLatestVersionQuery>({ document: GetDesignSrcFileLatestVersionDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getDesignSrcFileLatestVersion', 'query', variables);
    },
    getFigmaFileMetadata(variables: GetFigmaFileMetadataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetFigmaFileMetadataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetFigmaFileMetadataQuery>({ document: GetFigmaFileMetadataDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getFigmaFileMetadata', 'query', variables);
    },
    getFigmaUserInfo(variables: GetFigmaUserInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetFigmaUserInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetFigmaUserInfoQuery>({ document: GetFigmaUserInfoDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getFigmaUserInfo', 'query', variables);
    },
    deleteDesignSrcUser(variables: DeleteDesignSrcUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteDesignSrcUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteDesignSrcUserMutation>({ document: DeleteDesignSrcUserDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'deleteDesignSrcUser', 'mutation', variables);
    },
    getInvitedUsers(variables?: GetInvitedUsersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetInvitedUsersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetInvitedUsersQuery>({ document: GetInvitedUsersDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getInvitedUsers', 'query', variables);
    },
    inviteUser(variables: InviteUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<InviteUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InviteUserMutation>({ document: InviteUserDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'inviteUser', 'mutation', variables);
    },
    removeInvitedUser(variables: RemoveInvitedUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RemoveInvitedUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveInvitedUserMutation>({ document: RemoveInvitedUserDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'removeInvitedUser', 'mutation', variables);
    },
    getPage(variables: GetPageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPageQuery>({ document: GetPageDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getPage', 'query', variables);
    },
    getPageList(variables?: GetPageListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetPageListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPageListQuery>({ document: GetPageListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getPageList', 'query', variables);
    },
    getPattern(variables: GetPatternQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetPatternQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPatternQuery>({ document: GetPatternDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getPattern', 'query', variables);
    },
    getPatternList(variables?: GetPatternListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetPatternListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPatternListQuery>({ document: GetPatternListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getPatternList', 'query', variables);
    },
    updateSiteSetup(variables: UpdateSiteSetupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateSiteSetupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSiteSetupMutation>({ document: UpdateSiteSetupDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'updateSiteSetup', 'mutation', variables);
    },
    isGitConfiguredCorrectly(variables?: IsGitConfiguredCorrectlyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<IsGitConfiguredCorrectlyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IsGitConfiguredCorrectlyQuery>({ document: IsGitConfiguredCorrectlyDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'isGitConfiguredCorrectly', 'query', variables);
    },
    isAppClientConfiguredCorrectly(variables: IsAppClientConfiguredCorrectlyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<IsAppClientConfiguredCorrectlyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IsAppClientConfiguredCorrectlyQuery>({ document: IsAppClientConfiguredCorrectlyDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'isAppClientConfiguredCorrectly', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;